module.exports = __webpack_public_path__ + "img/flower_leaf_9.2d4ef25c.png";